import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        height: '40px',
        padding: theme.spacing(1),
        boxSizing: 'border-box',
        borderRadius: theme.spacing(1),
        border: `1px solid ${theme.colors.gray[200]}`,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
    },
    inputButton: {
        flex: '0 0 auto',
        backgroundColor: theme.colors.gray[100],
        height: '24px',
        border: `1px solid ${theme.colors.gray[200]}`,
        borderRadius: theme.spacing(0.5),
        padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
        '&:hover': {
            backgroundColor: theme.colors.gray[200],
            boxShadow: 'none',
        },
        boxShadow: 'none',
    },
    nativeInputButton: {
        visibility: 'hidden',
        position: 'absolute',
    },
    buttonText: Object.assign(Object.assign({}, theme.typography.body2), { color: theme.colors.text[900], fontSize: '12px', lineHeight: '16px', textTransform: 'none' }),
    fileName: {
        direction: 'rtl',
        marginLeft: theme.spacing(1),
        color: theme.colors.text[900],
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    clear: {
        position: 'absolute',
        right: 0,
        top: 0,
        transform: 'translateY(-100%)',
        minWidth: 0,
    },
    clearText: Object.assign(Object.assign({}, theme.typography.helpText), { color: theme.colors.primary.main, cursor: 'pointer', marginBottom: theme.spacing(0.5) }),
}));
//# sourceMappingURL=FileInput.styles.js.map